/* Tu Navidad · la ficha baja con position: sticky (CSS); aquí solo se mide el carril y se encienden las estaciones
   cuando su punto cruza la mitad de la pantalla (IntersectionObserver, sin escuchar el scroll).
   Fechas como el resto de la tienda: llega entre hoy + 10 y hoy + 19 días; ?hoy=AAAA-MM-DD para revisar.
   Con ?quieto=1 o «menos movimiento»: todo encendido y la ficha en la última estación. */
(() => {
  const qs = new URLSearchParams(location.search);
  const quieto = qs.has("quieto") || matchMedia("(prefers-reduced-motion: reduce)").matches;
  const CORTO = ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"];
  const hoy = qs.get("hoy") ? new Date(qs.get("hoy") + "T12:00:00") : new Date();
  const mas = (n) => { const d = new Date(hoy); d.setDate(d.getDate() + n); return d; };

  document.querySelectorAll("[data-tunav]").forEach((el) => {
    const d1 = mas(10), d2 = mas(19);
    el.querySelectorAll("[data-tunav-rango]").forEach((n) => (n.textContent = `${d1.getDate()} ${CORTO[d1.getMonth()]} – ${d2.getDate()} ${CORTO[d2.getMonth()]}`));
    el.querySelectorAll("[data-tunav-anio]").forEach((n) => (n.textContent = `Diciembre de ${hoy.getMonth() === 0 ? hoy.getFullYear() : hoy.getFullYear() + 1}`));
    // Una estación que ya no llega a tiempo (p. ej. Nochebuena si se pide después del 8 de diciembre) no se enseña
    el.querySelectorAll("[data-tunav-hasta]").forEach((li) => (li.hidden = hoy > new Date(li.dataset.tunavHasta + "T23:59:59")));

    const carril = el.querySelector(".tunav__carril");
    const nodos = [...el.querySelectorAll(".tunav__estacion:not([hidden]) .tunav__nodo")];
    if (!carril || nodos.length < 2) return;
    const medir = () => {
      const base = carril.getBoundingClientRect().top;
      const centro = (n) => { const r = n.getBoundingClientRect(); return r.top + r.height / 2 - base; };
      const a = centro(nodos[0]);
      el.style.setProperty("--n-arriba", `${a}px`);
      el.style.setProperty("--n-largo", `${centro(nodos[nodos.length - 1]) - a}px`);
    };
    medir();
    if ("ResizeObserver" in window) new ResizeObserver(medir).observe(carril);
    if (document.fonts) document.fonts.ready.then(medir);

    if (quieto || !("IntersectionObserver" in window)) { el.dataset.estado = "quieto"; return; }
    el.dataset.estado = "vivo";
    const io = new IntersectionObserver((entradas) => entradas.forEach((e) => {
      const pasada = e.isIntersecting ? e.intersectionRatio >= 0.5 : e.boundingClientRect.top < (e.rootBounds ? e.rootBounds.top : 0);
      e.target.closest(".tunav__estacion").classList.toggle("is-encendida", pasada);
    }), { rootMargin: "0px 0px -50% 0px", threshold: [0, 0.5, 1] });
    nodos.forEach((n) => io.observe(n));
  });
})();
